import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, getToken, clearToken } from "@/lib/api";
import RafflesAdmin from "@/components/admin/RafflesAdmin";
import WinnerHistory from "@/components/admin/WinnerHistory";

export default function RaffleLogPage() {
  const [authed, setAuthed] = useState(getToken() ? null : false);
  const [ver, setVer] = useState(0);
  const bump = () => setVer((v) => v + 1);
  useEffect(() => {
    if (!getToken()) return;
    api.get("/admin/verify").then(() => setAuthed(true)).catch(() => { clearToken(); setAuthed(false); });
  }, []);

  if (authed === false) return <Navigate to="/admin" replace />;
  if (authed === null) return <div className="text-zinc-500 text-sm">Loading…</div>;

  return (
    <div className="rise">
      <Link to="/admin" data-testid="back-to-admin" className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white transition-colors">
        <ArrowLeft className="h-4 w-4" /> Admin
      </Link>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-4">Fancall Raffle Log</h1>
      <p className="text-zinc-400 mt-2 text-sm md:text-base max-w-2xl">Every Fancall Round drop gets its own raffle round. Entries count automatically for joiners who opted in.</p>
      <WinnerHistory refreshKey={ver} onChanged={bump} />
      <h2 className="font-display text-base md:text-lg font-bold mt-10 mb-3">Raffle rounds</h2>
      <RafflesAdmin refreshKey={ver} onChanged={bump} />
    </div>
  );
}
